"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

// This is the default Northam fallback sales number. NOT Invoca
var initialState = {
  'sales-footer': '1 857 829 5060',
  'sales-middle': '1 857 829 5060',
  'crm-middle': '1 857 829 5060',
  'marketing-footer': '1 857 829 5060',
  'marketing-middle': '1 857 829 5060',
  'service-footer': '1 857 829 5060',
  'service-middle': '1 857 829 5060',
  'growthsuite-middle': '1 857 829 5060',
  'growthsuite-footer': '1 857 829 5060',
  'cms-footer': '1 857 829 5060',
  'cms-middle': '1 857 829 5060',
  bundle: '1 857 829 5060'
};

var PhoneNumbers = function PhoneNumbers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.PHONE_NUMBERS_RECEIVED:
      return payload.phoneNumbers;

    default:
      return state;
  }
};

var _default = PhoneNumbers;
exports.default = _default;
module.exports = exports.default;